import { useCallback, useMemo } from 'react';
import { useInstantSearch } from 'react-instantsearch';

import type { ExtendedUIState } from '@sorare/core/src/components/search/InstantSearch/types';
import { useVirtualToggleManager } from '@sorare/core/src/hooks/useVirtualToggleManager';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { useFiltersCount } from '#src/search/FiltersManager/useFiltersCount.ts';

import { SavedFiltersView } from './SavedFiltersView.tsx';
import type { CardFilters } from './updateCardFilters.ts';

export const SavedFilters = () => {
  const { indexUiState, setIndexUiState } = useInstantSearch<ExtendedUIState>();
  const filtersCount = useFiltersCount();
  const setVirtualToggleFilters = useVirtualToggleManager();

  const currentUiState: CardFilters = useMemo(() => {
    const uiStateWithVirtualToggle: CardFilters = indexUiState;

    return {
      ...(uiStateWithVirtualToggle.query
        ? { query: uiStateWithVirtualToggle.query }
        : {}),
      toggle: uiStateWithVirtualToggle.toggle ?? {},
      refinementList: uiStateWithVirtualToggle.refinementList ?? {},
      range: uiStateWithVirtualToggle.range ?? {},
      virtualToggle: uiStateWithVirtualToggle.virtualToggle ?? {},
      menu: uiStateWithVirtualToggle.menu ?? {},
    };
  }, [indexUiState]);

  const applyFilters = useCallback(
    (filters: CardFilters) => {
      setVirtualToggleFilters(
        {
          ...Object.fromEntries(
            Object.values(VIRTUAL_TOGGLE_FILTERS).map(filter => [
              filter.name,
              filter.defaultValue,
            ])
          ),
          ...filters.virtualToggle,
        },
        false
      );
      setIndexUiState(filters);
    },
    [setIndexUiState, setVirtualToggleFilters]
  );

  return (
    <SavedFiltersView
      currentUiState={currentUiState}
      filtersCount={filtersCount}
      applyFilters={applyFilters}
    />
  );
};
